export default "__VITE_ASSET__BVM_jYqi__"